import { type JSX, useState } from "react";
import { LoadingContext } from "./context/loading-context";
import { LoadingScreen } from "./components/loading-screen";

export const LoadingManager = (props: { children: JSX.Element }) => {
	const [isLodaing, setIsLoading] = useState(false);

	const startLoading = () => {
		setIsLoading(true);
	};

	const stopLoading = () => {
		setIsLoading(false);
	};

	return (
		<LoadingContext.Provider value={{ startLoading, stopLoading }}>
			{isLodaing && <LoadingScreen overlayScreen />}
			{props.children}
		</LoadingContext.Provider>
	);
};
